const CHECK_INTERVAL_MS = 5 * 60 * 1000;
const RELOAD_KEY = 'staleBuildReload';
const ownRelease = process.env.NEXT_PUBLIC_APP_RELEASE ?? null;

let deployedRelease : string | null = ownRelease;
let lastCheck = 0;

// True once the server has answered with a different release than this bundle was built from.
export const isBuildStale = () : boolean => deployedRelease !== ownRelease;

export async function checkBuildStale(force = false) : Promise<boolean> {
    if (isBuildStale() || (!force && Date.now() - lastCheck < CHECK_INTERVAL_MS)) return isBuildStale();

    lastCheck = Date.now();

    try {
        const response = await fetch('/api/release');

        if (response.ok) deployedRelease = (await response.json()).release ?? null;
    } catch {
        // Offline or mid-deploy: without an answer the build is not provably stale.
    }

    return isBuildStale();
}

// After a crash: an outdated bundle may not match the deployed API, so load the current one.
export async function reloadIfBuildStale() : Promise<void> {
    if (!await checkBuildStale(true)) return;

    try {
        // One reload per deployed release; a crash that survives it is a real bug.
        if (sessionStorage.getItem(RELOAD_KEY) === String(deployedRelease)) return;

        sessionStorage.setItem(RELOAD_KEY, String(deployedRelease));
    } catch {
        return;
    }

    window.location.reload();
}
